import React from 'react';
import logo from '../../logo.jpeg';

const ReceiptPrintView = ({ student }) => {
  if (!student) return null;

  const today = new Date().toLocaleDateString('en-GB'); // DD/MM/YYYY
  const receiptNo = student.receiptNo || '';
  
  const parseAmount = (val) => {
    if (val === null || val === undefined) return 0;
    const str = String(val).replace(/,/g, '').replace(/[₹$\s\/-]/g, '').trim();
    const num = parseFloat(str);
    return isNaN(num) ? 0 : num;
  };

  let amountReceivedVal = parseAmount(
    student.amountReceived !== undefined && student.amountReceived !== null && String(student.amountReceived).trim() !== ''
      ? student.amountReceived
      : (student.amountPaid || student.paidAmount || student.paid || 0)
  );

  const totalFeeVal = parseAmount(student.fee || student.totalFee || 0);

  const safeDueFees = student.dueFees !== undefined && student.dueFees !== null && String(student.dueFees).trim() !== ''
    ? parseAmount(student.dueFees)
    : Math.max(0, totalFeeVal - amountReceivedVal);

  // Automatic calculation fail-safe: If amountReceived is 0 or unparsed BUT total fees > due fees, calculate difference
  if (amountReceivedVal === 0 && totalFeeVal > 0 && totalFeeVal > safeDueFees) {
    amountReceivedVal = totalFeeVal - safeDueFees;
  }

  const displayDueFees = `₹ ${safeDueFees}`;

  const courseDisplay = (() => {
    if (student.courses && Array.isArray(student.courses) && student.courses.length > 0) {
      const validCourses = student.courses.filter(c => c && !/^\d{10}$/.test(String(c).trim()));
      if (validCourses.length > 0) return validCourses.join(', ');
    }
    if (student.course && !/^\d{10}$/.test(String(student.course).trim())) return student.course;
    if (student.batch && !/^\d{10}$/.test(String(student.batch).trim())) return student.batch;
    if (student.subject && !/^\d{10}$/.test(String(student.subject).trim())) return student.subject;
    return 'N/A';
  })();
  let dueDate = student.dueDate || '';
  if (!dueDate && safeDueFees > 0) {
    const d = new Date();
    d.setDate(d.getDate() + 30);
    dueDate = d.toLocaleDateString('en-GB');
  }

  const numberToWords = (num) => {
    const nStr = num ? num.toString() : '0';
    const nNum = parseInt(nStr, 10);
    if (isNaN(nNum) || nNum === 0) return 'Zero Only';
    const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    if (nStr.length > 9) return 'overflow';
    const n = ('000000000' + nStr).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return 'Zero Only';
    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.trim() + ' Only';
  };

  const borderStyle = '1px solid #000';

  const ReceiptSection = ({ title }) => (
    <div style={{ width: '100%', fontFamily: 'Arial, sans-serif', color: '#000', marginBottom: '6px', boxSizing: 'border-box' }}>
      <div style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '5px', fontSize: '13px' }}>{title}</div>
      
      <div style={{ border: '1.5px solid #000', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', background: '#fff' }}>
        {/* Header Info */}
        <div style={{ display: 'flex', borderBottom: borderStyle, boxSizing: 'border-box' }}>
          {/* Left Side: Company Info */}
          <div style={{ flex: '0 0 50%', borderRight: borderStyle, display: 'flex', gap: '10px', alignItems: 'center', padding: '6px 10px', boxSizing: 'border-box' }}>
            {/* Logo */}
            <img src={logo || "/image.png"} alt="Logo" style={{ width: '46px', height: '46px', objectFit: 'contain', border: '1px solid #000', padding: '2px', flexShrink: 0 }} />
            <div>
              <div style={{ fontWeight: 'bold', fontSize: '13.5px', marginBottom: '3px' }}>BK Educational & Welfare Society</div>
              <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1px 0' }}>2nd Floor, Gajanan Plaza, Behind Lotus Capital Building,</div>
              <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1px 0' }}>Gharpure Ghat Road, Ashok Stambh, Nashik-422002, Maharashtra</div>
              <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1px 0' }}>Email : bkgroupofeducation1@gmail.com</div>
              <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1px 0' }}>Contact No. : 8888301363</div>
              <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1px 0' }}>Website : https://www.bkeducation.co.in/</div>
            </div>
          </div>
          {/* Right Side: Student Info */}
          <div style={{ flex: '0 0 50%', padding: '6px 12px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div style={{ fontWeight: 'bold', fontSize: '13.5px', marginBottom: '4px', textTransform: 'uppercase' }}>{student.name || ''}</div>
            <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1.5px 0' }}>Address : {student.address || ''}</div>
            <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1.5px 0' }}>Email : {student.email || ''}</div>
            <div style={{ fontSize: '9.5px', color: '#222', lineHeight: '1.3', margin: '1.5px 0' }}>Contact No. : {student.studentPhone || student.studentContact || student.phone || student.mobile || student.contact || student.fingerprint_id || ''}</div>
          </div>
        </div>

        {/* Title */}
        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '12px', borderBottom: borderStyle, padding: '3px 0', background: '#fff', textTransform: 'uppercase', letterSpacing: '0.5px', boxSizing: 'border-box' }}>
          FEES RECEIPT
        </div>

        {/* Date & Receipt No */}
        <div style={{ display: 'flex', borderBottom: borderStyle, fontSize: '11px', boxSizing: 'border-box' }}>
          <div style={{ flex: '0 0 50%', borderRight: borderStyle, padding: '4px 8px', boxSizing: 'border-box' }}><strong>Receipt Date :</strong> {student.enquiryDate || today}</div>
          <div style={{ flex: '0 0 50%', padding: '4px 8px', boxSizing: 'border-box' }}><strong>Receipt No. :</strong> {receiptNo}</div>
        </div>

        {/* Course & Amount */}
        <div style={{ display: 'flex', borderBottom: borderStyle, fontSize: '11px', boxSizing: 'border-box' }}>
          <div style={{ flex: '0 0 50%', borderRight: borderStyle, padding: '4px 8px', fontWeight: 'bold', boxSizing: 'border-box' }}>
            Courses : <span style={{fontWeight: 'normal'}}>{courseDisplay}</span>
          </div>
          <div style={{ flex: '0 0 50%', boxSizing: 'border-box' }}></div>
        </div>
        <div style={{ display: 'flex', borderBottom: borderStyle, fontSize: '11px', boxSizing: 'border-box' }}>
          <div style={{ flex: '0 0 50%', borderRight: borderStyle, padding: '4px 8px', fontWeight: 'bold', boxSizing: 'border-box' }}>
            Amount received : <span style={{fontWeight: 'normal'}}>₹ {amountReceivedVal}</span>
          </div>
          <div style={{ flex: '0 0 50%', boxSizing: 'border-box' }}></div>
        </div>
        <div style={{ display: 'flex', borderBottom: borderStyle, fontSize: '11px', boxSizing: 'border-box' }}>
          <div style={{ flex: '0 0 50%', borderRight: borderStyle, padding: '4px 8px', fontWeight: 'bold', boxSizing: 'border-box' }}>
            Amount received (in words) : <span style={{fontWeight: 'normal'}}>{numberToWords(amountReceivedVal)}</span>
          </div>
          <div style={{ flex: '0 0 50%', boxSizing: 'border-box' }}></div>
        </div>

        {/* Payment Details Grid */}
        <div style={{ display: 'flex', fontSize: '11px', boxSizing: 'border-box' }}>
          {/* Left Column */}
          <div style={{ flex: '0 0 50%', borderRight: borderStyle, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Payment mode :</strong> {student.paymentMode || ''}</div>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Total Fees :</strong> {student.fee ? `₹ ${student.fee}` : ''}</div>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Installment (Yes/No) :</strong> {student.installment || 'No'}</div>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Due Date :</strong> {dueDate}</div>
            <div style={{ padding: '4px 8px', boxSizing: 'border-box' }}><strong>Due Fees :</strong> {displayDueFees}</div>
          </div>
          {/* Right Column */}
          <div style={{ flex: '0 0 50%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Cheque/Txn No. :</strong> {student.txnNo || 'N/A'}</div>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Bank Name :</strong> {student.bankName || 'N/A'}</div>
            <div style={{ padding: '4px 8px', borderBottom: borderStyle, boxSizing: 'border-box' }}><strong>Account No :</strong> {student.accountNumber || 'N/A'}</div>
            <div style={{ padding: '4px 8px', boxSizing: 'border-box' }}><strong>IFSC Code :</strong> {student.ifscCode || 'N/A'}</div>
          </div>
        </div>

        {/* Terms */}
        <div style={{ borderTop: borderStyle, padding: '4px 8px 3px 8px' }}>
          <strong style={{ fontSize: '9.5px', display: 'block', marginBottom: '2px' }}>Terms & Conditions :</strong>
          <div style={{ fontSize: '8.5px', color: '#444', lineHeight: '1.3' }}>
            <div>1. All above mentioned Amount once paid are non refundable in any case whatsoever.</div>
            <div>2. Late payment will attract extra charges.</div>
            <div>3. Fees are non-transferable to another student/course.</div>
          </div>
          <div style={{ textAlign: 'center', fontSize: '8.5px', fontStyle: 'italic', marginTop: '3px', color: '#333', fontWeight: 'bold' }}>
            This is computer-generated receipt. No signature is required for validation.
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="receipt-print-container printable-receipt-view">
      <ReceiptSection title="Student's Copy" />
      
      <div style={{ display: 'flex', alignItems: 'center', margin: '8px 0', opacity: 0.8 }}>
        <div style={{ flex: 1, borderTop: '1px dashed #000' }}></div>
        <div style={{ padding: '0 10px', fontSize: '9.5px', fontStyle: 'italic', color: '#333' }}>✂ Fold or Cut along this line</div>
        <div style={{ flex: 1, borderTop: '1px dashed #000' }}></div>
      </div>
      
      <ReceiptSection title="Office Copy" />
      
      <style>{`
        .printable-receipt-view {
          visibility: hidden;
          position: absolute;
          pointer-events: none;
          height: 0;
          overflow: hidden;
        }
        @media print {
          @page {
            size: A4 portrait;
            margin: 0 !important;
          }

          body.print-blank-receipt .blank-receipt-container {
            display: block !important;
            visibility: visible !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            z-index: 999999 !important;
          }

          body.print-blank-receipt .blank-receipt-container .printable-receipt-view,
          body.print-receipt .printable-receipt-view {
            display: block !important;
            visibility: visible !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            height: auto !important;
            background: white !important;
            margin: 0 auto !important;
            padding: 8mm 10mm 8mm 10mm !important;
            box-sizing: border-box !important;
            z-index: 999999 !important;
            page-break-after: avoid !important;
            page-break-inside: avoid !important;
            break-after: avoid !important;
            break-inside: avoid !important;
          }

          body.print-all-receipts .all-receipts-print-container .printable-receipt-view,
          body.print-processed-receipts .processed-receipts-print-container .printable-receipt-view {
            display: block !important;
            visibility: visible !important;
            position: relative !important;
            width: 100% !important;
            height: auto !important;
            background: white !important;
            margin: 0 auto !important;
            padding: 8mm 10mm 8mm 10mm !important;
            box-sizing: border-box !important;
            page-break-after: always !important;
            page-break-inside: avoid !important;
            break-after: page !important;
            break-inside: avoid !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ReceiptPrintView;

